<template>

    <ul class="list-group notification-message-element-content"></ul>

</template>

<script>

    export default{
        name: 'ListMessageElement'
    }

</script>